// 克罗地亚语
const hr = {
  common: {
    notSupport: 'Vaš preglednik ne podržava način rada preko cijelog zaslona',
    loadFail: 'Učitavanje teme nije uspjelo',
    noPermission: 'Nažalost, nemate dopuštenje za pristup toj stranici',
    backHome: 'Povratak na početnu stranicu',
    noExit: 'Stranica koju pokušavate otvoriti ne postoji',
    serverError: 'Nažalost, došlo je do pogreške na poslužitelju',
    slide: 'Prijeđite prstom udesno',
    veryHigh: 'Vrlo visoka',
    high: 'Visoka',
    target: 'Cilj',
    urgentLow: 'Vrlo niska',
    agpNoData: 'AGP izvještaj zahtijeva najmanje 5 dana podataka',
    noDataStr: 'Nema podataka',
    setting: 'Postavke',
    personInfo: 'Osnovne informacije',
    updatePwd: 'Promijeni lozinku',
    upHead: 'Učitaj slike',
    inRange: 'U rasponu',
    normal: 'Normalno',
    low: 'Nisko',
    previous: 'Prethodno',
    next: 'Sljedeće',
    search: 'Pretraži',
    reset: 'Poništi',
    cancel: 'Odustani',
    ok: 'U redu',
    confirm: 'Potvrdi',
    save: 'Spremi',
    submit: 'Pošalji',
    successful: 'Uspješno',
    pleaseEnter: 'Unesite',
    pleaseSelect: 'Odaberite',
    success: 'Uspjeh',
    confirmLogout: 'Jeste li sigurni da se želite odjaviti?',
    updateSuccessed: 'Ažuriranje je bilo uspješno',
    warning: 'Upozorenje',
    date: 'Datum',
    start: 'Početak',
    end: 'Kraj',
    sevenDays: '7 dana',
    fourteenDays: '14 dana',
    thirtyDays: '30 dana',
    signOut: 'Odjava',
    personalInformation: 'Osobni podaci',
    email: 'Email',
    name: 'Ime',
    mobile: 'Mobitel',
    dateOfBirth: 'Datum rođenja',
    gender: 'Spol',
    diabeteType: 'Vrsta dijabetesa',
    dateOfDignose: 'Godina dijagnoze',
    remarks: 'Napomena',
    optionMale: 'Muško',
    optionFemale: 'Žensko',
    optionUnknow: 'Ne želim navesti',
    noDiabetes: 'Bez dijabetesa',
    diabeteTypeI: 'Tip I',
    diabeteTypeII: 'Tip II',
    diabeteSpecial: 'Posebno',
    diabeteGestational: 'Gestacijski dijabetes',
    diabeteOthers: 'Ostalo',
    ruleMsgEmail: 'Unesite email',
    ruleMsgName: 'Unesite ime',
    ruleMsgMobile: 'Unesite broj mobitela',
    ruleMsgBirthday: 'Odaberite datum rođenja',
    ruleMsgSex: 'Odaberite spol',
    ruleMsgDiabeteType: 'Odaberite vrstu dijabetesa',
    ruleMsgDateOfDignose: 'Odaberite godinu dijagnoze',
    ruleMsgRemarks: 'Unesite napomenu',
    ruleMsgCorrectMobile: 'Unesite ispravan broj mobitela',
    oldPassword: 'Stara lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    ruleMsgOldPassword: 'Unesite staru lozinku',
    ruleMsgNewPassword: 'Unesite novu lozinku',
    ruleMsgConfirmPassword: 'Potvrdite lozinku',
    passwordInconsistent: 'Lozinke se ne podudaraju',
    passwordModifySuccessed: 'Lozinka je poništena, prijavite se ponovno!',
    monday: 'Pon',
    tuesday: 'Uto',
    wednesday: 'Sri',
    thursday: 'Čet',
    friday: 'Pet',
    saturday: 'Sub',
    sunday: 'Ned',
    sn: 'SN',
    startDate: 'Datum početka',
    days: 'dana',
    pdfDate: 'Cilj',
    close: 'zatvori',
    inputTip: 'Unesite ključne riječi za pretraživanje',
    polarization: 'Pokretanje uređaja u tijeku',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Izvještaj nije generiran zadnjih 5 dana',
    age: 'dob',
    goal: 'Cilj',
    expired: 'Senzor istekao',
    lastTime: 'Vrijeme zadnjeg osvježavanja',
    timeZone: 'Vremenska zona'
  },
  route: {
    login: 'Prijava',
    forget: 'Zaboravljena lozinka',
    home: 'Početna',
    glucoseReport: 'Izvještaj o glukozi',
    sessionReport: 'Izvještaj o sesiji',
    eventList: 'Popis događaja',
    followerList: 'Popis pratitelja',
    followerListQ: 'Zahtjevi za praćenje',
    settings: 'Postavke',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Zapamti me',
    forgetPassword: 'Zaboravljena lozinka',
    agree: 'Prijavom se slažete s uvjetima FurCarer-a',
    privacyPolicy: 'Pravila privatnosti',
    CGMUser: 'CGM korisnik',
    follower: 'Pratitelj',
    ruleMsgPassword: 'Unesite lozinku',
    login: 'Prijavi se',
    phonePlacehold: 'Unesite broj telefona',
    codePlacehold: 'Unesite verifikacijski kod',
    codePlaceholdInput: 'Unesite t...',
    phoneTip: 'Po telefonu',
    emialTip: 'Po emailu',
    codeTip: 'Dobij kod',
    reGetTip: 'Ponovno dohvaćanje'
  },
  layout: {
    collapseUp: 'Sakrij izbornik',
    collapseDown: 'Proširi izbornik',
    refresh: 'Osvježi',
    backHome: 'Početna',
    helpCenter: 'Centar za pomoć',
    fullScreen: 'Cijeli zaslon'
  },
  forget: {
    ruleMsgCode: 'Unesite kod',
    sendCode: 'Pošalji kod',
    tipsMsgSendSuccess: 'Kod je uspješno poslan!',
    tipsMsgModifySuccess: 'Promjena lozinke uspješna'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Glukoza danas',
    todaysOverview: 'Pregled danas',
    maxGlucose: 'Maks. glukoza',
    minGlucose: 'Min. glukoza',
    avgGlucose: 'Prosj. glukoza',
    maxmumVariation: 'Maksimalna varijacija',
    glucose: 'Glukoza',
    tir: 'TIR',
    latestGlucose: 'Zadnja glukoza',
    todayPercentage: '% dana u različitim rasponima',
    fourHour: '4 sata',
    eightHour: '8 sati',
    twelveHour: '12 sati',
    twentyFourHour: '24 sata',
    glucoseOnly: 'Samo glukoza',
    sessionOverview: 'Pregled sesije',
    glocuseMetrics: 'Metrički podaci o glukozi',
    agp: 'AGP',
    dailyGlucose: 'Dnevna glukoza',
    sessionGlucose: 'Glukoza po sesijama',
    standTir: 'Standardni TIR',
    customTir: 'Prilagođeni TIR',
    cancleGz: 'Prestani pratiti',
    cancleText: 'Želite li prestati pratiti ovog korisnika?',
    helpCenterTip: 'Funkcija još nije dostupna'
  },
  glucoseReport: {
    statics: 'Statistika',
    sixHour: 'TIR za 6 sati',
    avgGlucose: 'Prosj. glukoza',
    maxGlucose: 'Maks. glukoza',
    minGlucose: 'Min. glukoza',
    cv: 'CV',
    high: 'Broj vis. vrijednosti',
    low: 'Broj niskih vrijednosti',
    normal: 'Broj normalnih vrijednosti',
    tir: 'TIR',
    estimatedA1c: 'Procijenjeni HbA1c',
    min: 'Min',
    avg: 'Pros',
    max: 'Maks',
    maxVariation: 'Maks. varijacija'
  },
  glucoseProfile: {
    avg: 'Pros',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Sve',
    bg: 'BG',
    meal: 'Obrok',
    sport: 'Sport',
    insulin: 'Inzulin',
    alert: 'Upozorenje',
    eventType: 'Vrsta događaja',
    description: 'Opis',
    note: 'Napomena',
    highAlert: 'upozorenje',
    calibration: 'Kalibracija',
    meds: 'Lijekovi',
    time: 'Vrijeme',
    detail: 'Detalji',
    weigt: 'Težina'
  },
  followerList: {
    title: 'Korisnici za praćenje',
    tabTitle: 'Upravljanje pratiteljima',
    refreshText:
      'Automatsko osvježavanje (popis se automatski osvježava svakih 30 sekundi)',
    addText: 'Dodaj',
    dataText: 'Podaci dohvaćeni',
    timeText: 'minuta',
    hourText: 'sati',
    agoText: ' prije',
    tableEmail: 'Unesite broj računa',
    searchPlacehold: 'Unesite broj računa za pretragu',
    pending: 'Na čekanju',
    approved: 'Odobreno',
    rejected: 'Odbijeno',
    addFollower: 'Dodaj pratitelja',
    editFollower: 'Uredi pratitelja',
    tableName: 'Ime',
    tableAddTime: 'Vrijeme dodavanja',
    tableStatus: 'Status',
    tableApproved: 'Odobreno',
    tableReject: 'Odbij',
    tableStartSharing: 'Započni dijeljenje podataka',
    tableStopSharing: 'Prekini dijeljenje podataka',
    op: 'Radnja',
    sharing: 'Dijeljenje',
    notSharing: 'Bez dijeljenja',
    tableRemove: 'ukloni',
    note: 'Napomena',
    message: 'Poruka',
    ruleMsgEmailEmpty: 'Unesite email za pretragu',
    ruleMsgNote: 'Unesite napomenu',
    ruleMsgMessage: 'Ostavite poruku',
    ruleMsgEmailCorrect: 'Unesite ispravan email',
    formAcknowledge:
      'Dodavanjem pratitelja ovaj korisnik će moći vidjeti vaše podatke',
    sendFollowRequest: 'Pošalji zahtjev za praćenje',
    setNote: 'Postavi napomenu',
    tipsAcknowledge:
      'Označite kućicu kojom potvrđujete da dodavanje pratitelja omogućava prikaz vaših podataka',
    stopSharing: 'Zaustavi dijeljenje',
    startSharing: 'Započni dijeljenje',
    removeUser: 'Ukloni korisnika',
    confirmStopSharing:
      'Jeste li sigurni da želite prestati dijeliti podatke s ovim korisnikom?',
    confirmStartSharing:
      'Jeste li sigurni da želite započeti dijeljenje s ovim korisnikom?',
    confirmRemove:
      'Jeste li sigurni da želite ukloniti ovog korisnika s popisa?',
    approvedFollower: 'Odobren pratitelj',
    rejectFollower: 'Odbijen pratitelj',
    confirmApproved: 'Jeste li sigurni da želite odobriti zahtjev za praćenje?',
    confirmReject: 'Jeste li sigurni da želite odbiti zahtjev za praćenje?',
    addTime: 'Vrijeme dodavanja',
    check: 'Provjeri',
    remove: 'Ukloni',
    removeUserTitle:
      'Jeste li sigurni da želite ukloniti ovog korisnika s popisa?'
  },
  settings: {
    title: 'Postavke razine glukoze',
    unitSet: 'Postavke jedinica',
    targetSet: 'Prilagođene TIR postavke',
    alertSet: 'Postavke upozorenja',
    highAlert: 'Upozorenje za visoku vrijednost',
    lowAlert: 'Upozorenje za nisku vrijednost',
    urgentLow: 'Hitno niska',
    urgentHigh: 'Hitno visoka',
    target: 'Cilj'
  },
  pdf: {
    dailyStatistics: 'Dnevna statistika',
    title: 'AGP izvještaj',
    page: 'Stranica',
    generated: 'Generirano',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Vrijeme u rasponu',
    timeInRange: 'Vrijeme u rasponu (TIR)',
    agpTitle: 'Ambulantni profil glukoze (AGP)',
    agpSubTitle:
      'AGP je sažetak vrijednosti glukoze iz razdoblja izvješća, s medijanom (50%) i ostalim percentilima prikazanim kao da su se dogodili u jednom danu',
    dailyTitle: 'Dnevni profil glukoze',
    dailySubTitle:
      'Svaki dnevni profil predstavlja razdoblje od ponoći do ponoći.',
    device: 'Uređaj',
    tDevice: 'Terminalni uređaj',
    print: 'Ispis',
    model: 'Model',
    deviceSn: 'Serijski broj uređaja',
    effectiveData: 'Učinkoviti podaci',
    days: 'Dani',
    appVer: 'Verzija aplikacije',
    smartPhoneModel: 'Model pametnog telefona',
    osVersion: 'Verzija OS-a',
    appSetting: 'Postavke aplikacije',
    GoalsforType1andType2Diabetes: 'Ciljevi za dijabetes tipa 1 i tipa 2',
    Each1timeinrange15minutes: 'Svaki 1% vremena u rasponu ≈ ~15 minuta',
    note: 'Napomena: Postotna jedinica (%) primjenjuje se za DCCT standard, a jedinica mmol/mol primjenjuje se za IFCC standard.',
    DOB: 'Datum rođenja',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'Vrijeme aktivnog CGM-a',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Prosj. kalibracija po danu',
    glucoseAbility: 'Varijabilnost glukoze',
    lage: 'LAGE',
    mage: 'MAGE',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Vrijeme kalibracije'
  },
  agp: {
    agpTitle: 'Ambulantni profil glukoze (AGP)',
    centerLine: 'Medijan',
    areaLine: 'Interval',
    target: 'Ciljni raspon'
  },
  basic: {
    customTir: 'Prilagođeni TIR',
    bloodTip: 'Postavke podsjetnika za glukozu',
    bloodUnit: 'Jedinica za glukozu',
    highTip: 'Upozorenje na visoku glukozu',
    lowTip: 'Upozorenje na nisku glukozu',
    unitText: 'Automatsko postavljanje prema zemlji/regiji',
    selectTip:
      'Kliknite na ikonu za odabir ili poništavanje odgovarajućeg datuma',
    selectAll: 'Odaberi sve'
  },
  report: {
    threeMonth: 'Zadnja 3 mjeseca',
    sixMonth: 'Gotovo 6 mjeseci',
    yearText: 'Prošla godina',
    showAll: 'Prikaži sve',
    all: 'Sve',
    selectDate: 'Odaberite raspon datuma',
    to: 'do',
    startDt: 'Datum početka',
    endDt: 'Datum završetka',
    betaTest: 'Beta testiranje',
    bloodData: 'Podaci o glukozi',
    userCount: 'Korisnički račun'
  },
  petDetail: {
    variety: 'Pasma',
    type: 'Vrsta inzulina',
    freq: 'Učestalost inzulina',
    lente: 'Lente',
    insulin: 'Inzulin Glargin',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP izvještaj',
    snNumber: 'SN',
    page: 'Stranica',
    createTime: 'Generirano',
    petInfo: 'Podaci o ljubimcu',
    petName: 'Ime ljubimca',
    birthday: 'Datum rođenja',
    freq: 'Učestalost inzulina',
    petType: 'Vrsta ljubimca',
    age: 'Dob',
    registerType: 'Vrsta štrcaljke',
    basicBloodData: 'Metrički podaci glukoze',
    dbText: 'Vrijeme u rasponu (TIR)',
    target: 'Ciljevi za dijabetes tipa 1 i tipa 2',
    recordTime: 'Vrijeme snimanja',
    tag: 'oznaka',
    event: 'Događaj',
    eventDetail: 'Detalji događaja',
    mulityText: 'Graf više dnevnih trendova glukoze',
    mulitySubText:
      'Višednevni profili glukoze predstavljaju vremenski interval ciklusa uređaja',
    avageBlood: 'Prosječna glukoza',
    bloodText: 'MODD',
    highTip: 'Upozorenje na visoku glukozu',
    lowTip: 'Upozorenje na nisku glukozu',
    cat: 'Mačka',
    dog: 'Pas',
    country: 'Zemlja',
    insulinDose: 'Doza inzulina',
    weightUnit: 'kg'
  },
  eventDetail: {
  Empty: 'Doručak',
  After_Breakfast: 'Nakon doručka',
  Before_Lunch: 'Prije ručka',
  Breakfast: 'Doručak',
  Lunch: 'Ručak',
  Dinner: 'Večera',
  Before_Sleep: 'Prije spavanja',
  Extra: 'Dodatno',
  Short_acting: 'Kratkodjelujući',
  Pre_mixed: 'Predmiješani',
  Long_acting: 'Dugodjelujući',
  Middle_acting: 'Srednjedjelujući',
  hour: 'h',
  minutes: 'min'
}
};
export default hr;
